import {alias, createModelSchema, list} from "serializr";
import {SmartOfferBundle} from "../bundle-core/SmartOfferBundle";
import {SmartOfferBundleKind} from "../bundle-core/SmartOfferBundleKind";
import {RewardBunch} from "@/modules/redactor/models/reward/RewardBunch";
import {CardAlbumModel} from "@/modules/redactor/models/card/CardAlbumModel";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";
import {Schema} from "@/common/Schema";
import {Currency} from "@/modules/redactor/models/currency/Currency";
import {ProductModel} from "@/modules/redactor/models/product/ProductModel";


export class SmartOfferBundleCollection extends SmartOfferBundle {

    constructor() {
        super(SmartOfferBundleKind.COLLECTION);

        this._albums = [];
        this._previewCards = [];
        this._rewardBunch = null;

        this._saleDuration = 0;
        this._cardPrice = [];

        this._shopCardpack = [];
        this._shopDuplicate = [];
    }

    get albums() {
        return this._albums;
    }

    set albums(value) {
        this._albums = value;
    }

    get previewCards() {
        return this._previewCards;
    }

    set previewCards(value) {
        this._previewCards = value;
    }

    get rewardBunch() {
        return this._rewardBunch;
    }

    set rewardBunch(value) {
        this._rewardBunch = value;
    }

    get saleDuration() {
        return this._saleDuration;
    }

    set saleDuration(value) {
        this._saleDuration = value;
    }

    get cardPrice() {
        return this._cardPrice;
    }

    set cardPrice(value) {
        this._cardPrice = value;
    }

    get shopCardpack() {
        return this._shopCardpack;
    }

    set shopCardpack(value) {
        this._shopCardpack = value;
    }

    get shopDuplicate() {
        return this._shopDuplicate;
    }

    set shopDuplicate(value) {
        this._shopDuplicate = value;
    }

    valid() {

        if (!super.valid()) {
            return false;
        }

        if (this.albums.length === 0 || this.albums.some(v => !v || !v.valid())) {
            return false;
        }

        if (!this.previewCards || this.previewCards.length !== 3) {
            return false;
        }

        if (this.previewCards && this.previewCards.some(v => !v || !RedactorUtils.getCard(v))) {
            return false;
        }

        if (!this.rewardBunch || this.rewardBunch.empty()) {
            return false;
        }

        if (this.rewardBunch && !this.rewardBunch.valid()) {
            return false;
        }

        if (!Number.isInteger(this.saleDuration) || this.saleDuration < 0) {
            return false;
        }

        if (this.cardPrice.length === 0 && this.saleDuration > 0) {
            return false;
        }

        if (this.cardPrice.some(v => !v || !v.valid())) {
            return false;
        }

        if (!this.shopCardpack || this.shopCardpack.some(v => !v || !v.valid())) {
            return false;
        }

        if (!this.shopDuplicate || this.shopDuplicate.some(v => !v || !v.valid())) {
            return false;
        }

        return true;
    }

    empty() {

        if (!this.albums || this.albums.length === 0) {
            return true;
        }

        if (!this.rewards || this.rewards.empty()) {
            return true;
        }

        return super.empty();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new SmartOfferBundleCollection());
        } else if (target instanceof SmartOfferBundleCollection) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(SmartOfferBundleCollection, {
    _albums: alias("albums", list(CardAlbumModel.schema())),
    _previewCards: alias("preview_cards", list(Schema.primitive())),
    _rewardBunch: alias("reward_bunch", RewardBunch.schema()),
    _saleDuration: alias("sale_duration", Schema.primitive()),
    _cardPrice: alias("card_price", list(Currency.schema())),
    _shopCardpack: alias("shop_cardpack", list(ProductModel.schema())),
    _shopDuplicate: alias("shop_duplicate", list(ProductModel.schema()))
});
